import { ColumnSetting } from '../../../../_foundation/models/grid.models';

export const fieldPositioningColumns: ColumnSetting[] = [
  {
    field: 'activity',
    title: 'Activity',
    filter: 'text'
  },
  {
    field: 'showPinnedTimeFull',
    title: 'Date',
    filter: 'date'
  },
  {
    field: 'showPinnedTime',
    title: 'Pinned Time',
    filter: 'text'
  },

  {
    field: 'showLastModifiedDate',
    title: 'Last Updated',
    filter: 'date'
  },
  {
    field: 'lastModifiedBy',
    title: 'Last Updated By',
    filter: 'text'
  },
  {
    field: 'status',
    title: 'Status',
    filter: 'text'
  },
  {
    field: 'actions',
    title: '',
    filterable: false,
    width: 300
  }
];



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v1/jacking-activity-list-component/field-positioning-list-component.config.ts